import { useMedia } from 'react-use';
import { Box } from '@qga/roo-ui/components';
import theme from 'styles/theme';
import DepositPayActions from '../DepositPayActions';
import ManageBookingActions from './ManageBookingActions';

const MobileTabletManageBookingActions = () => {
  const isTablet = useMedia(`(max-width: ${theme.breakpoints[1]})`);
  return isTablet ? (
    <Box p={0} mb={[5, 8, 0]} minWidth="100%">
      <DepositPayActions />
      <ManageBookingActions />
    </Box>
  ) : null;
};

export default MobileTabletManageBookingActions;
